import React from "react";
import { Paper, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";

type ReactMarkdownStyledProps = {
  markdown: any;
};

const ReactMarkdownStyled: React.FC<ReactMarkdownStyledProps> = ({ markdown }) => {
  if (!markdown.trim()) {
    return null;
  }

  return (
      <ReactMarkdown
        rehypePlugins={[[rehypeHighlight as any]]}
      >
        {markdown}
      </ReactMarkdown>
  );
};

export default ReactMarkdownStyled